
const settings = {
	//remote: '//vg.archivestud.io/'
	remote: '//live.villagegreenstudio.com/'
}

export default settings



// WEBPACK FOOTER //
// ./src/js/settings.js